export default {
  situacao: {
    value: '',
    options: [
      { text: 'Débito', value: 'DEBITO' },
      { text: 'Crédito', value: 'CREDITO' }
    ],
    required: true,
    state: null
  },
  codigo: {
    value: '0',
    required: true,
    state: null
  },
  boardId: {
    listOptions: [],
    value: null,
    required: true
  },
  boardColumnId: {
    listOptions: [],
    value: null,
    required: true
  }

}



// WEBPACK FOOTER //
// ./src/views/private/configurations/parametros/cardMovimentation/components/add/movimentationadd-form.js